/**
 * @name 阿里云地址
 * */
export enum URL_TYPE {
  // 普教oss地址
  aliyunPath = 'https://fs.iclass30.com/',
  // 综评oss地址
  pjPath = 'https://pjcdn.iclass30.com/',
  // 高教obs地址
  obsPath = 'https://fileobsc30.iclass30.com/'
}

/**
 * @name 管理员类型
 * */
export enum ADMIN_TYPE {
  /** 非管理员 */
  NOADMIN,
  /** 总管理员 */
  SYSTEMADMIN,
  /** 校级管理员 */
  SCHOOLADMIN,
  /** 班级管理员 */
  CLASSADMIN,
}
/**
 * @name 用户类型
 * */
export enum USER_TYPE {
  /** 注册用户 */
  REGISTER,
  /** 教师 */
  TEACHER,
  /** 学生 */
  STUDENT,
  /** 家长 */
  PARENT,
  /** 代理商 */
  AGENT,
  /** 运营 */
  OPERATE,
  /** 区域管理员 */
  REGION,
}
/**
* @name 学段类型
* */
export enum PHASE_TYPE {
  //全部
  all = "-1",
  //幼儿园
  kinder = "0",
  /** 小学 */
  primary = '1',
  /** 初中 */
  junior = '2',
  /** 高中 */
  high = '3',
  //中职
  secondary = "4",
  //高职
  vocational = "5",
  //大学
  university = "6",
  //特殊学校
  special = "7",
  // 其他
  other = "8",
}